/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import {
  Row,
  Col,
  Badge,
  Button,
  Drawer,
  Typography,
  Spin,
  Avatar,
  Divider,
  Space,
  Tag,
  Alert,
  Modal,
} from "antd";

import {
  UserOutlined,
  LogoutOutlined,
  SafetyCertificateOutlined,
  CrownOutlined,
  DollarOutlined,
  TeamOutlined,
  CustomerServiceOutlined,
  ShopOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";

import { useAdminPermissions } from "../../context/AdminContext";

const logsetting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#111827"
    ></path>
  </svg>,
];

const profile = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
      fill="#111827"
    ></path>
  </svg>,
];

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

const setting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#111827"
    ></path>
  </svg>,
];

function Header({ placement, onPress }) {
  const { Title, Text } = Typography;
  const { hasRouteAccess, admin, loading, permissions, logout } =
    useAdminPermissions();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const showDrawer = () => setVisible(true);
  const hideDrawer = () => setVisible(false);

  // Configuration des rôles avec icônes et couleurs
  const getRoleConfig = (role) => {
    const configs = {
      super_admin: {
        icon: <CrownOutlined />,
        color: "#ff4d4f",
        bgColor: "#fff2f0",
        name: "Super Administrateur",
      },
      admin_global: {
        icon: <SafetyCertificateOutlined />,
        color: "#fa8c16",
        bgColor: "#fff7e6",
        name: "Administrateur Global",
      },
      manager_financier: {
        icon: <DollarOutlined />,
        color: "#52c41a",
        bgColor: "#f6ffed",
        name: "Manager Financier",
      },
      manager_utilisateurs: {
        icon: <TeamOutlined />,
        color: "#1890ff",
        bgColor: "#e6f7ff",
        name: "Manager Utilisateurs",
      },
      support_analyste: {
        icon: <CustomerServiceOutlined />,
        color: "#722ed1",
        bgColor: "#f9f0ff",
        name: "Support Analyste",
      },
      agent_commercial: {
        icon: <ShopOutlined />,
        color: "#eb2f96",
        bgColor: "#fff0f6",
        name: "Agent Commercial",
      },
    };

    return (
      configs[role] || {
        icon: <UserOutlined />,
        color: "#666",
        bgColor: "#f5f5f5",
        name: role,
      }
    );
  };

  const handleLogout = () => {
    Modal.confirm({
      title: "Confirmer la déconnexion",
      icon: <LogoutOutlined />,
      content: "Êtes-vous sûr de vouloir vous déconnecter ?",
      okText: "Oui, me déconnecter",
      cancelText: "Annuler",
      okType: "danger",
      onOk: () => {
        logout();
        hideDrawer();
      },
    });
  };

  // Afficher un état de chargement si les permissions ne sont pas encore chargées
  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <Spin tip="Chargement..." />
      </div>
    );
  }

  // Si aucun admin n'est connecté
  if (!admin) {
    return null;
  }

  const roleConfig = getRoleConfig(admin.role);
  const accessCount = permissions.allowedRoutes?.length || 0;
  const hasLimitedAccess = accessCount <= 2;

  return (
    <>
      <div className="setting-drwer" onClick={showDrawer}>
        {setting}
      </div>
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}></Col>
        <Col span={24} md={18} className="header-control">
          <Badge
            count={accessCount}
            style={{ backgroundColor: roleConfig.color }}
          >
            <Button type="link" onClick={showDrawer}>
              {logsetting}
            </Button>
          </Badge>
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>

          {/* Drawer avec toutes les informations */}
          <Drawer
            className="settings-drawer"
            mask={true}
            width={400}
            onClose={hideDrawer}
            placement={placement}
            open={visible}
            title={
              <Space>
                <UserOutlined />
                <span>Profil & Permissions</span>
              </Space>
            }
          >
            {/* Section Profil Admin */}
            <div style={{ marginBottom: 24 }}>
              <div
                style={{
                  padding: "20px",
                  backgroundColor: roleConfig.bgColor,
                  borderRadius: "8px",
                  border: `1px solid ${roleConfig.color}30`,
                }}
              >
                <Space
                  direction="vertical"
                  style={{ width: "100%" }}
                  size="middle"
                >
                  {/* Avatar et nom */}
                  <div style={{ textAlign: "center" }}>
                    <Avatar
                      size={80}
                      style={{
                        backgroundColor: roleConfig.color,
                        fontSize: "32px",
                      }}
                      icon={<UserOutlined />}
                    />
                    <Title level={4} style={{ margin: "12px 0 4px 0" }}>
                      {admin.fullname}
                    </Title>
                    <Text type="secondary" style={{ fontSize: "13px" }}>
                      {admin.email}
                    </Text>
                  </div>

                  <Divider style={{ margin: "12px 0" }} />

                  {/* Rôle avec badge */}
                  <div>
                    <Text strong style={{ fontSize: "12px", color: "#666" }}>
                      Rôle administrateur
                    </Text>
                    <div style={{ marginTop: "6px" }}>
                      <Tag
                        icon={roleConfig.icon}
                        color={roleConfig.color}
                        style={{ padding: "6px 12px", fontSize: "13px" }}
                      >
                        {roleConfig.name}
                      </Tag>
                    </div>
                  </div>

                  {/* Téléphone */}
                  <div>
                    <Text strong style={{ fontSize: "12px", color: "#666" }}>
                      Téléphone
                    </Text>
                    <div style={{ marginTop: "4px" }}>
                      <Text>{admin.phone || "Non renseigné"}</Text>
                    </div>
                  </div>

                  {/* Statut */}
                  <div>
                    <Text strong style={{ fontSize: "12px", color: "#666" }}>
                      Statut du compte
                    </Text>
                    <div style={{ marginTop: "4px" }}>
                      <Badge
                        status={admin.is_active ? "success" : "error"}
                        text={admin.is_active ? "Actif" : "Inactif"}
                      />
                    </div>
                  </div>

                  {/* Dernière connexion */}
                  {admin.last_login_at && (
                    <div>
                      <Text strong style={{ fontSize: "12px", color: "#666" }}>
                        Dernière connexion
                      </Text>
                      <div style={{ marginTop: "4px" }}>
                        <Text>
                          {new Date(admin.last_login_at).toLocaleString(
                            "fr-FR",
                          )}
                        </Text>
                      </div>
                    </div>
                  )}
                </Space>
              </div>
            </div>

            <Divider />

            {/* Section Permissions */}
            <div style={{ marginBottom: 24 }}>
              <Title level={5} style={{ marginBottom: 16 }}>
                <InfoCircleOutlined style={{ marginRight: 8 }} />
                Permissions d'accès
              </Title>

              {/* Nombre d'accès */}
              <div
                style={{
                  padding: "16px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  marginBottom: 16,
                }}
              >
                <Space direction="vertical" style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Text strong>Sections accessibles</Text>
                    <Badge
                      count={accessCount}
                      style={{
                        backgroundColor: roleConfig.color,
                        fontSize: "16px",
                        padding: "0 12px",
                      }}
                      showZero
                    />
                  </div>
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    Vous avez accès à {accessCount} section
                    {accessCount > 1 ? "s" : ""} du dashboard
                  </Text>
                </Space>
              </div>

              {/* Message d'alerte si accès limité */}
              {hasLimitedAccess && (
                <Alert
                  message="Accès limité"
                  description={
                    <div>
                      Votre rôle vous donne accès à un nombre limité de
                      sections. Contactez votre administrateur système si vous
                      pensez avoir besoin de privilèges supplémentaires.
                    </div>
                  }
                  type="warning"
                  showIcon
                  icon={<WarningOutlined />}
                  style={{ marginBottom: 16 }}
                />
              )}

              {/* Liste des routes accessibles */}
              {permissions.allowedRoutes &&
                permissions.allowedRoutes.length > 0 && (
                  <div>
                    <Text
                      strong
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginBottom: 8,
                        display: "block",
                      }}
                    >
                      Routes autorisées
                    </Text>
                    <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: "1px solid #f0f0f0",
                        borderRadius: "6px",
                        padding: "8px",
                      }}
                    >
                      <Space
                        direction="vertical"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        {permissions.allowedRoutes.map((route, index) => (
                          <div
                            key={index}
                            style={{
                              padding: "6px 10px",
                              backgroundColor: "#fafafa",
                              borderRadius: "4px",
                              fontSize: "12px",
                              fontFamily: "monospace",
                            }}
                          >
                            {route}
                          </div>
                        ))}
                      </Space>
                    </div>
                  </div>
                )}
            </div>

            <Divider />

            {/* Section Informations supplémentaires */}
            <div style={{ marginBottom: 24 }}>
              <div
                style={{
                  padding: "16px",
                  backgroundColor: "#e6f7ff",
                  borderRadius: "8px",
                  border: "1px solid #91d5ff",
                }}
              >
                <Space direction="vertical" size="small">
                  <Text strong style={{ color: "#0050b3" }}>
                    À propos de votre compte
                  </Text>
                  <Text style={{ fontSize: "12px", lineHeight: 1.6 }}>
                    Compte créé le{" "}
                    <strong>
                      {new Date(admin.created_at).toLocaleDateString("fr-FR")}
                    </strong>
                  </Text>
                  <Text style={{ fontSize: "12px", lineHeight: 1.6 }}>
                    ID: <strong>#{admin.id}</strong>
                  </Text>
                </Space>
              </div>
            </div>

            {/* Bouton de déconnexion */}
            <Button
              type="primary"
              danger
              size="large"
              icon={<LogoutOutlined />}
              block
              onClick={handleLogout}
              style={{
                height: "50px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Se déconnecter
            </Button>

            {/* Footer d'aide pour certains rôles */}
            {shouldShowHelpFooter(admin.role) && (
              <div style={{ marginTop: 24 }}>
                <div
                  style={{
                    padding: "16px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "8px",
                    color: "white",
                  }}
                >
                  <h6
                    style={{
                      color: "white",
                      marginBottom: "8px",
                      fontSize: "14px",
                    }}
                  >
                    Besoin d'aide ?
                  </h6>
                  <p
                    style={{
                      fontSize: "12px",
                      margin: "0 0 12px 0",
                      opacity: 0.9,
                    }}
                  >
                    Notre équipe support est disponible pour vous assister
                  </p>
                  <Button
                    type="default"
                    size="small"
                    block
                    style={{
                      backgroundColor: "rgba(255,255,255,0.2)",
                      borderColor: "rgba(255,255,255,0.3)",
                      color: "white",
                    }}
                  >
                    CONTACTER LE SUPPORT
                  </Button>
                </div>
              </div>
            )}
          </Drawer>

          <div className="btn-sign-in">
            {profile}
            <span>{admin.fullname}</span>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Header;

// Fonction utilitaire pour déterminer si on doit afficher le footer d'aide
function shouldShowHelpFooter(role) {
  const rolesWithHelpFooter = ["support_analyste", "agent_commercial"];
  return rolesWithHelpFooter.includes(role);
}
